
import { useEffect, useRef } from "react";
import Pusher from "pusher-js";

const usePusher = ({ channelName, eventName, onEvent }) => {
  const pusherRef = useRef(null);
  const channelRef = useRef(null);
  const token = localStorage.getItem("token");

  // 🔹 Create Pusher ONCE
  useEffect(() => {
    if (!token || pusherRef.current) return;

    Pusher.logToConsole = false;


    pusherRef.current = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
      cluster: "eu",  
      forceTLS: true,
      authEndpoint: "https://dayemapp.com/brq/api/v1/broadcasting/auth",
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      },
    });

    return () => {
      if (pusherRef.current?.connection?.state === "connected") {
        pusherRef.current.disconnect();
      }
      pusherRef.current = null;
    };
  }, [token]);

  // 🔹 Handle channel + event binding
  useEffect(() => {
    if (!pusherRef.current || !channelName || !eventName) return;

    // Unsubscribe old channel first
    if (channelRef.current) {
      channelRef.current.unbind_all();
      pusherRef.current.unsubscribe(channelRef.current.name);
    }

    const channel = pusherRef.current.subscribe(channelName);
    channelRef.current = channel;

    const handleEvent = (data) => {
      console.log(`📡 [${channelName}] ${eventName}`, data);
      onEvent?.(data);
    };

    channel.bind(eventName, handleEvent);

    return () => {
      channel.unbind(eventName, handleEvent);
    };
  }, [channelName, eventName, onEvent]);
};

export default usePusher;